/* ==========================================================================
   VELOUS - product page enhancements. Theme v2.

   Deliberately small and defensive. Everything here is progressive: if the
   markup it expects is not present, it does nothing and the page behaves
   exactly as it would without this file. It never touches cart state,
   variant selection or the product form's values - Impulse owns all of
   that, and it works.

   One job: a sticky Add to cart on mobile. On the current PDP the button
   sits roughly two screens down, after the description. This surfaces it.
   The sticky button SCROLLS TO the real buy box and focuses it rather than
   submitting a second form, so there is no duplicate submit path and
   nothing that can drift out of sync with the selected variant.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function initStickyAtc() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.vlp-sticky')) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var realBtn = form.querySelector('[type="submit"], button[name="add"], .product-form__cart-submit');
    if (!realBtn) return;

    var titleEl = document.querySelector('.product-single__title');
    var priceEl = document.querySelector('.product__price, .product-block--price .product__price');

    var bar = document.createElement('div');
    bar.className = 'vlp-sticky';
    bar.setAttribute('role', 'complementary');
    bar.setAttribute('aria-label', 'Add to cart');

    var txt = document.createElement('div');
    txt.className = 'vlp-sticky__t';
    var b = document.createElement('b');
    b.textContent = priceEl ? priceEl.textContent.trim() : '';
    var small = document.createElement('small');
    small.textContent = titleEl ? titleEl.textContent.trim() : '';
    txt.appendChild(b);
    txt.appendChild(small);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Add to cart';
    btn.addEventListener('click', function () {
      try {
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          try { realBtn.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
        }, 380);
      } catch (e) {
        realBtn.scrollIntoView();
      }
    });

    bar.appendChild(txt);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    // Keep the price in the bar honest when Impulse swaps variants.
    if (priceEl && 'MutationObserver' in window) {
      try {
        new MutationObserver(function () {
          b.textContent = priceEl.textContent.trim();
        }).observe(priceEl, { childList: true, characterData: true, subtree: true });
      } catch (e) { /* not critical */ }
    }

    // Show the bar only once the real button has scrolled out of view.
    if ('IntersectionObserver' in window) {
      try {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-on', !entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -40px 0px' }).observe(realBtn);
      } catch (e) {
        bar.classList.add('is-on');
      }
    } else {
      bar.classList.add('is-on');
    }
  }

  ready(function () {
    try { initStickyAtc(); } catch (e) { /* never break the page */ }
  });
})();
